export default __webpack_public_path__ + "static/media/row.c470f09c.svg";